import {
  FETCH_CONFIGURATOR_PAGE_FIELDS,
  TOGGLE_HOLDER_RING_MODAL,
  TOGGLE_MAIN_RING_MODAL,
  CLOSE_MODALS,
} from "./types";

import ContentfulApi from "../../lib/ContentfulApi";

export const fetchConfiguratorPageFields = () => {
  return (dispatch) => {
    const api = new ContentfulApi();

    api
      .getConfiguratorPageFields()
      .then((response) => {
        const formattedResponse = formatConfiguratorPageFields(response);
        dispatch({
          type: FETCH_CONFIGURATOR_PAGE_FIELDS,
          payload: formattedResponse,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

const formatConfiguratorPageFields = (response) => {
  if (
    response &&
    response.items &&
    response.items.length &&
    response.includes &&
    response.includes.Asset &&
    response.includes.Asset.length
  ) {
    const ringImageID = response.items[0].fields.selectRingImage.sys.id;
    const holderRingImageID =
      response.items[0].fields.selectHolderRingImage.sys.id;
    for (let i = 0; i < response.includes.Asset.length; i++) {
      if (response.includes.Asset[i].sys.id === ringImageID) {
        response.items[0].fields.selectRingImageURL =
          "https://" + response.includes.Asset[i].fields.file.url.substring(2);
      }
      if (response.includes.Asset[i].sys.id === holderRingImageID) {
        response.items[0].fields.selectHolderRingImageURL =
          "https://" + response.includes.Asset[i].fields.file.url.substring(2);
      }
    }
    return response;
  }
  return response;
};

export const toggleRingSelectModal = (mainRing = true) => {
  return (dispatch) => {
    if (mainRing) {
      dispatch({
        type: TOGGLE_MAIN_RING_MODAL,
      });
    } else {
      dispatch({
        type: TOGGLE_HOLDER_RING_MODAL,
      });
    }
  };
};

export const closeRingSelectModals = () => {
  return (dispatch) => {
    dispatch({
      type: CLOSE_MODALS,
    });
  };
};
